import store from '@/store'

export function getVisited(key) {
  var map = store.getters.visited
  var count = map[key]
  if(!count){
    count = 0
  }
  count = count+1
  map[key]=count
  store.dispatch('visited',map)
  return count
}